<template>
  <div class="investment-input">
    <SingleInput
      v-model="quantityValue"
      type="number"
      placeholder="0"
      prefix=""
      show-clear-button
      :status="status"
      :helper-text="helperText"
      @input="handleChange"
      @on-clear="onClear"
    />
    <ShortcutValue
      v-if="shortcutValue.length > 0"
      class="investment-input__shortcut"
      :values="shortcutValue"
      :disabled="loading"
      @click="shortcutClick"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { SingleInput, ShortcutValue } from '@warrenbrasil/nebraska-web';

import { IShortcutValue } from './types';

interface Props {
  shortcutValue: IShortcutValue[];
  status?: string;
  value?: number;
  helperText?: string;
  loading?: boolean;
}
withDefaults(defineProps<Props>(), {
  status: '',
  helperText: '',
  value: 0,
  loading: false
});

interface EmitEvents {
  (event: 'change', value: number): void;
}
const emit = defineEmits<EmitEvents>();

const quantityValue = ref('0');

function handleChange(value: string) {
  quantityValue.value = value;

  emitChange();
}

function onClear() {
  quantityValue.value = '0';

  emitChange();
}

function shortcutClick(data: IShortcutValue) {
  quantityValue.value = (Number(quantityValue.value) + data.value).toString();

  emitChange();
}

function emitChange() {
  emit('change', Number(quantityValue.value));
}
</script>

<style lang="less" scoped>
.investment-input {
  &__shortcut {
    margin-top: @size-spacing-x400;
  }

  &__button-container {
    display: flex;
  }

  &__button {
    background-color: @background-tertiary;
    margin-left: @size-spacing-x300;
  }
}
</style>
